const myJourney = {
    eyebrow: 'ניסיון',
    myJourney: 'המסע שלי בתחום',
    description: 'מפיתוח פול-סטאק ועד הנדסת AI — הצוותים, האתגרים והטכנולוגיות שמאחורי כל שלב.',
    current: 'נוכחי',
};

export default myJourney;
